import React, { PureComponent } from 'react';
import moment from 'moment';
import styled from 'styled-components';

import ModalContainer from '../../../components/shared/modal/ModalContainer';
import { PrimaryButton } from '../../../components/shared/sharedStyles.styles';
import { Container, SpanTitle, GrayText } from '../../../pages/operational/request/form/fieldModal/formModalFields.styled';

const CopyPixButton = styled(PrimaryButton)`
  margin: 14px auto 0 !important;
  display: block !important;
  min-height: 36px;
  width: 100%;
  max-width: 260px;
  padding: 0.42rem 0.8rem !important;
  font-size: 0.82rem !important;
  line-height: 1.2 !important;
  letter-spacing: 0.02em !important;
  text-align: center;
  white-space: nowrap;
`;

class ModalCancelarCobranca extends PureComponent {

	state = {
		copied: false
	}

  renderFooter = () => (
    null
    // <StyledRow padding='0 3em' justify="space-around">
    //   {/* <PrimaryButton data-testid="send-data-button" onClick={this.props.onClose}>Cancelar</PrimaryButton> */}
    //   <PrimaryButton data-testid="go-back-button" disabled={!this.props.justificativa} onClick={this.props.undo} >Enviar Solicitação</PrimaryButton>
    // </StyledRow>
  )

  renderHeader = () => (
    <SpanTitle customstyle="margin: auto;">
      Pagamento por Pix
      <div>(ID COBRANÇA: {this.props.selectedIdCobranca})</div>
    </SpanTitle>
  )

  copyText = () => {
    navigator.clipboard.writeText(this.props.pixCopiaECola);
		this.setState({copied: true})
		setTimeout(() => {
			this.setState({copied: false})
		}, 3000)
  }

  render() {
		let date = this.props.pixCriacao
		if(date) {
			Date.prototype.addHours = function(h) {
				this.setTime(this.getTime() + (h*60*60*1000));
				return this;
			}
			date = new Date(date).addHours(1)
		}
    

    return (
      <ModalContainer
        isOpen={this.props.isOpen}
        size="lg"
        showCloseIcon={true}
        onClose={this.props.onClose}
        closeModal={this.props.onClose}
        footer={this.renderFooter()}
        header={this.renderHeader()}
      >

        <Container customstyle="text-align: center; margin: 20px auto;">
          <GrayText>
            <div style={{textAlign: 'left', color: '#152b4e'}}>
              {/* <label>Justificativa:</label> */}
              <div style={{marginBottom: 14}}>Para usar o "Pix Copia e Cola" copie o código e cole para completar a transação.</div>
              <div style={{backgroundColor: '#f2f2f2', padding: 14, wordBreak: 'break-all', borderRadius: 4}}>{this.props.pixCopiaECola}</div>
              <CopyPixButton data-testid="go-back-button" onClick={this.copyText} disabled={this.state.copied}>
                {this.state.copied === true ? 'Copiado' : 'Copiar código Pix'}
              </CopyPixButton>
              
              <div style={{marginTop: 14}}>Código válido até: <b>{moment(date).format('DD/MM/YYYY H:mm:ss')}</b></div>
              <div>Valor: <b>R$ {this.props.formatToBRL(this.props.valorFinal)}</b></div>

              <div style={{marginTop: 14}}>1. Abra o app do seu banco</div>
              <div>2. Escolha a opção Pagar com Copia e Cola</div>
              <div>3. Confirme as informações e finalize o pagamento</div>
              <div>4. Aguarde e em breve você será notificado</div>
            </div>
            {/* <input style={{display: 'block', width: '100%', borderTop: 'none', borderRight: 'none', borderLeft: 'none', borderBottom: '1px solid #b0afaf', outline: 'none'}} onChange={this.props.handleJustificativa} /> */}
          </GrayText>
        </Container>

      </ModalContainer>
    );
  }
}

export default ModalCancelarCobranca;